import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class CurrencyService {
    getCurrencySymbol(currencyCode: string): string {
        const currencySymbols: { [key: string]: string } = {
            'EUR': '€',
            'USD': '$',
            'GBP': '£',
            'JPY': '¥',
            'CNY': '¥',
            'CHF': 'CHF',
            'CAD': 'CA$',
            'AUD': 'A$',
            'NZD': 'NZ$',
            'SEK': 'kr',
            'NOK': 'kr',
            'DKK': 'kr',
            'PLN': 'zł',
            'CZK': 'Kč',
            'HUF': 'Ft',
            'RON': 'lei',
            'BGN': 'лв',
            'HRK': 'kn',
            'TRY': '₺',
            'RUB': '₽',
            'INR': '₹',
            'BRL': 'R$',
            'MXN': 'MX$',
            'ARS': 'AR$',
            'CLP': 'CL$',
            'COP': 'CO$',
            'PEN': 'S/',
            'ZAR': 'R',
            'ILS': '₪',
            'AED': 'د.إ',
            'SAR': '﷼',
            'KRW': '₩',
            'SGD': 'S$',
            'HKD': 'HK$',
            'THB': '฿',
            'MYR': 'RM',
            'IDR': 'Rp',
            'PHP': '₱',
            'VND': '₫',
            'TWD': 'NT$'
        }
        return currencySymbols[currencyCode] || currencyCode
    }
}
